import * as S from "../../Style/Page/Car.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitleCar.js";
import HatPageTopLine from "../../Component/CarPageTopLine.js";
const Bus1 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/48. 코스타리카법인 CRD400.cf77856290baf43e57af.png`;
const Bus2 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/49. 코스타리카법인 CRD300.f400c6063664066f51d1.png`;
const Factory6 = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"상용버스사업"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <Link to="/BusBusiness/OverseasBus">
                <div className="kor">버스사업</div>
                <div className="eng">Bus Business</div>
              </Link>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">Fork Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"156px"}>
            <S.NavItem>
              <Link to="/BusBusiness/Factory">
                <div className="kor">생산공장</div>
                <div className="eng">production plant</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">해외 상용버스사업</div>
                  <div className="eng">Overseas commercial bus business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory">
                  <div className="kor">생산공장</div>
                  <div className="eng">production plant</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/BusBusinessHistory">
                  <div className="kor">버스사업이력</div>
                  <div className="eng">Major business history</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"312px"}>
            <S.NavItem>
              <Link to="/BusBusiness/Factory6">
                <div className="kor">코스타리카 법인</div>
                <div className="eng">Costa Rica Sales Corporation</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory">
                  <div className="kor">베트남 생산공장</div>
                  <div className="eng">Vietnam Production Plant</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory2">
                  <div className="kor">베트남 부품공장</div>
                  <div className="eng">Vietnam Parts Manufacturing</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory3">
                  <div className="kor">중국 계림 법인</div>
                  <div className="eng">China Production Plant</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory4">
                  <div className="kor">파키스탄 공장</div>
                  <div className="eng">Pakistan Production Plant</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory5">
                  <div className="kor">카자흐스탄 공장</div>
                  <div className="eng">Kazakhstan Production Plant</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory6">
                  <div className="kor">코스타리카 법인</div>
                  <div className="eng">Costa Rica Sales Corporation</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>
        <div className="wrap">
          <div className="inner">
            <PageTitle
              titleko={"코스타리카 법인"}
              titleeng={"Sales Corporation"}
              link={"http://www.daewoobuscr.com/"}
            />
            <div className="page-text">Daewoo Bus Costa Rica S.A.</div>

            <PageTitle titleko={"주요 판매 차종"} titleeng={"Major Sales model"} />
            <div className="page-text"></div>
            <div className="sale-bus-list">
              <div className="sale-bus-item">
                <img src={Bus1} alt="" className="sale-bus-img" />
                <div className="sale-bus-name">CRD400</div>
              </div>
              <div className="sale-bus-item">
                <img src={Bus2} alt="" className="sale-bus-img" />
                <div className="sale-bus-name">CRD300</div>
              </div>
            </div>

            <PageTitle titleko={"주요 이력"} titleeng={"Key History"} />
            <div className="page-text">
              <div className="page-text-flex">
                <div className="page-text-area">
                  <div className="page-text-title">
                    <div className="kor">Daewoo Bus Costa Rica S.A. 법인개요</div>
                    <div className="eng">Daewoo Bus Costa Rica S.A. Status</div>
                  </div>
                  <div className="kor">
                    법인 설립: 1995년 7월 16일 (영안에서 마우코 지분 100% 인수)
                    <br />
                    코스타리카 법인 설립 (대우버스 50% / 영안개발 50%) : 2003년
                    <br />
                    코스타리카 판매법인으로 전환: 2021년
                    <br />
                    대우버스에서 자일자동차로 투자자 변경 (자일자동차 99% / CMHI
                    1%): 2021년
                    <br />
                  </div>
                  <div className="eng">
                    Established: 1995. 7. 16 (Youngan acquired Mauco's shares 100%)
                    <br />
                    Established Daewoo Bus Costa Rica Corp.
                    <br />
                    (Daewoo Bus 50% / Youngan Development 50%) : 2003
                    <br />
                    Converted into Sales Corporation: 2021
                    <br />
                    Investor changed from Daewoo Bus to Zyle Motors (Zyle 99% / CMHI 1%): 2021
                  </div>
                </div>
              </div>
              <div className="kor">※ 중대형 버스 및 부품 판매</div>
              <div className="eng">※ Mid & Large bus and parts sales</div>
            </div>
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default Factory6;
